import { RouterModule, Routes } from '@angular/router';

export const routes: Routes = [
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    { path: 'about', loadChildren: function() { return new Promise(function (resolve, reject) {  (require as any).ensure([], function (require: any) {    resolve(require('.\\about\\about.module')['AboutModule']);  }, function(e: any) {    reject({ loadChunkError: true, details: e });  });}) }}
];

export const AppRoutes = RouterModule.forRoot(routes);
